import { useSelector } from 'react-redux';

export const FiscalRepresentative=({renderForm})=>{
  const dataSource=useSelector((state) => state.Actor.fiscal)

  return renderForm ? renderForm({
    actorType:"fiscal",
    boxNumber:"14",
    disabled:false,
    actorName:"Fiscal Representative Name",
    dataSource:dataSource

  })
  : null
    
}